(function(){
  'use strict';

  function toast(message){
    var old=document.querySelector('.uc-article__toast');
    if(old) old.remove();
    var el=document.createElement('div');
    el.className='uc-article__toast';
    el.setAttribute('role','status');
    el.setAttribute('aria-live','polite');
    el.setAttribute('aria-atomic','true');
    el.textContent=message;
    document.body.appendChild(el);
    setTimeout(function(){el.remove();},2200);
  }

  function slug(text,index){
    return (text||'section').toLowerCase().trim().replace(/[^a-z0-9\s-]/g,'').replace(/\s+/g,'-').replace(/-+/g,'-')+'-'+index;
  }

  function fileSlug(text){
    return (text||'urban-calm-learning-centre-guide').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'').slice(0,72)||'urban-calm-learning-centre-guide';
  }

  function wrapText(ctx,text,maxWidth){
    var words=(text||'').trim().split(/\s+/).filter(Boolean), lines=[], line='';
    words.forEach(function(word){
      var test=line?line+' '+word:word;
      if(line && ctx.measureText(test).width>maxWidth){lines.push(line);line=word;}else{line=test;}
    });
    if(line) lines.push(line);
    return lines;
  }

  function drawWrapped(ctx,text,x,y,maxWidth,lineHeight,maxLines){
    var lines=wrapText(ctx,text,maxWidth);
    if(maxLines && lines.length>maxLines){
      lines=lines.slice(0,maxLines);
      var last=lines[lines.length-1];
      while(last.length>1 && ctx.measureText(last+'…').width>maxWidth){last=last.slice(0,-1);}
      lines[lines.length-1]=last.replace(/[\s,.!?;:]+$/,'')+'…';
    }
    lines.forEach(function(line,i){ctx.fillText(line,x,y+(i*lineHeight));});
    return y+(lines.length*lineHeight);
  }

  function roundRect(ctx,x,y,w,h,r){
    var radius=Math.min(r,w/2,h/2);
    ctx.beginPath();ctx.moveTo(x+radius,y);ctx.arcTo(x+w,y,x+w,y+h,radius);ctx.arcTo(x+w,y+h,x,y+h,radius);ctx.arcTo(x,y+h,x,y,radius);ctx.arcTo(x,y,x+w,y,radius);ctx.closePath();
  }

  function firstUsefulTextAfter(heading){
    var node=heading.nextElementSibling;
    while(node && !/^H[23]$/.test(node.tagName)){
      if(node.matches && node.matches('p,ul,ol,blockquote')){
        var text=(node.textContent||'').replace(/\s+/g,' ').trim();
        if(text) return text;
      }
      node=node.nextElementSibling;
    }
    return '';
  }

  function collectSummary(content){
    var points=[];
    var heads=Array.prototype.slice.call(content.querySelectorAll('h2'));
    if(heads.length<2) heads=Array.prototype.slice.call(content.querySelectorAll('h2,h3'));
    heads.slice(0,4).forEach(function(h){
      points.push({title:(h.textContent||'').trim(),text:firstUsefulTextAfter(h)});
    });
    if(points.length<3){
      var paras=Array.prototype.slice.call(content.querySelectorAll('p')).map(function(p){return (p.textContent||'').replace(/\s+/g,' ').trim();}).filter(function(t){return t.length>45;});
      while(points.length<4 && paras.length){
        var idx=points.length;
        points.push({title:'Key takeaway '+(idx+1),text:paras.shift()});
      }
    }
    return points.slice(0,4);
  }

  function makeSummaryCanvas(article,content){
    var canvas=document.createElement('canvas');canvas.width=1080;canvas.height=1350;
    var ctx=canvas.getContext('2d');if(!ctx)return null;
    var bg='#F5F1E9', ink='#1F211D', green='#244132', muted='#65675F', line='rgba(31,33,29,.15)';
    ctx.fillStyle=bg;ctx.fillRect(0,0,1080,1350);
    ctx.fillStyle=green;ctx.fillRect(0,0,1080,150);
    ctx.strokeStyle='rgba(255,255,255,.08)';ctx.lineWidth=2;[120,205,290].forEach(function(r){ctx.beginPath();ctx.arc(1030,20,r,0,Math.PI*2);ctx.stroke();});

    var left=82,right=998,width=right-left;
    ctx.fillStyle='#fff';ctx.font='700 42px Arial, Helvetica, sans-serif';ctx.fillText('URBAN CALM',left,78);
    ctx.font='700 16px Arial, Helvetica, sans-serif';ctx.fillStyle='rgba(255,255,255,.72)';ctx.fillText('COFFEE  •  MUSHROOMS  •  ORIGIN',left,111);

    var title=(article.querySelector('h1')||{}).textContent||document.title;
    ctx.fillStyle=green;ctx.font='700 18px Arial, Helvetica, sans-serif';ctx.fillText('GUIDE SUMMARY',left,205);
    ctx.fillStyle=ink;ctx.font='700 57px Arial, Helvetica, sans-serif';
    var y=drawWrapped(ctx,title.trim(),left,280,width,64,3);

    var dek=article.querySelector('.uc-article__dek');
    if(dek){ctx.fillStyle=muted;ctx.font='400 25px Arial, Helvetica, sans-serif';y=drawWrapped(ctx,(dek.textContent||'').trim(),left,y+16,width,35,2)+18;}

    var points=collectSummary(content);
    var start=Math.max(y+15,475), gap=14;
    var remaining=1160-start, cardH=Math.min(154,Math.max(130,(remaining-gap*Math.max(points.length-1,0))/Math.max(points.length,1)));
    points.forEach(function(point,i){
      var py=start+i*(cardH+gap);
      roundRect(ctx,left,py,width,cardH,18);ctx.fillStyle='#fff';ctx.fill();ctx.strokeStyle=line;ctx.lineWidth=1.5;ctx.stroke();
      ctx.fillStyle=green;ctx.font='700 20px Arial, Helvetica, sans-serif';ctx.fillText(String(i+1).padStart(2,'0'),left+24,py+38);
      ctx.fillStyle=ink;ctx.font='700 26px Arial, Helvetica, sans-serif';drawWrapped(ctx,point.title,left+78,py+39,width-108,31,2);
      if(point.text){ctx.fillStyle=muted;ctx.font='400 19px Arial, Helvetica, sans-serif';drawWrapped(ctx,point.text,left+78,py+92,width-108,26,2);}
    });

    ctx.strokeStyle=line;ctx.beginPath();ctx.moveTo(left,1260);ctx.lineTo(right,1260);ctx.stroke();
    ctx.fillStyle=green;ctx.font='700 19px Arial, Helvetica, sans-serif';ctx.fillText('urbancalmcoffee.ca',left,1304);
    ctx.fillStyle=muted;ctx.font='400 17px Arial, Helvetica, sans-serif';ctx.textAlign='right';ctx.fillText('Read the full guide in the Learning Centre',right,1304);ctx.textAlign='left';
    return canvas;
  }

  function dataUrlToBlob(dataUrl){
    var parts=dataUrl.split(','), mime=(parts[0].match(/:(.*?);/)||[])[1]||'image/png', binary=atob(parts[1]), bytes=new Uint8Array(binary.length);
    for(var i=0;i<binary.length;i++)bytes[i]=binary.charCodeAt(i);
    return new Blob([bytes],{type:mime});
  }

  function saveBlob(blob,name){
    var url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download=name;document.body.appendChild(a);a.click();a.remove();setTimeout(function(){URL.revokeObjectURL(url);},1000);
  }

  function shareSummary(button,article,content){
    var original=button.textContent;button.setAttribute('aria-busy','true');button.textContent='Creating…';
    try{
      var canvas=makeSummaryCanvas(article,content);if(!canvas)throw new Error('Canvas unavailable');
      var blob=dataUrlToBlob(canvas.toDataURL('image/png'));
      var title=(article.querySelector('h1')||{}).textContent||document.title;
      var name=fileSlug(title)+'-summary.png', file=null;
      try{file=new File([blob],name,{type:'image/png'});}catch(e){}
      if(file&&navigator.share&&navigator.canShare&&navigator.canShare({files:[file]})){
        navigator.share({title:title,text:'Urban Calm Learning Centre',url:window.location.href,files:[file]}).catch(function(err){if(err&&err.name!=='AbortError'){saveBlob(blob,name);toast('Social summary saved');}});
      }else{saveBlob(blob,name);toast('Social summary saved — ready to post');}
    }catch(err){
      if(navigator.clipboard){navigator.clipboard.writeText(window.location.href).then(function(){toast('Could not build the image, so the article link was copied');});}
    }finally{button.removeAttribute('aria-busy');button.textContent=original;}
  }

  function init(){
    var article=document.querySelector('[data-uc-article]');if(!article)return;
    var content=article.querySelector('[data-uc-article-content]');
    var toc=article.querySelector('[data-uc-toc]');
    var tocWrap=article.querySelector('[data-uc-toc-wrap]');
    if(content&&toc){
      var heads=content.querySelectorAll('h2,h3');
      if(heads.length<2){if(tocWrap){var first=tocWrap.querySelector('.uc-article__rail-card:first-child');if(first)first.style.display='none';}}
      else Array.prototype.forEach.call(heads,function(h,i){if(!h.id)h.id=slug(h.textContent,i+1);var li=document.createElement('li');li.className=h.tagName==='H3'?'uc-toc--h3':'';var a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent;li.appendChild(a);toc.appendChild(li);});
    }

    var progress=document.querySelector('[data-uc-reading-progress]');
    function updateProgress(){if(!progress)return;var rect=article.getBoundingClientRect();var total=article.offsetHeight-window.innerHeight;var passed=Math.min(Math.max(-rect.top,0),Math.max(total,1));progress.style.width=(passed/Math.max(total,1)*100)+'%';}
    updateProgress();window.addEventListener('scroll',updateProgress,{passive:true});window.addEventListener('resize',updateProgress);

    document.addEventListener('click',function(e){
      var copy=e.target.closest('[data-uc-copy-link]');
      if(copy&&navigator.clipboard){navigator.clipboard.writeText(window.location.href).then(function(){toast('Link copied');});return;}
      var share=e.target.closest('[data-uc-native-share]');
      if(share){if(navigator.share){navigator.share({title:document.title,url:window.location.href}).catch(function(){});}else if(navigator.clipboard){navigator.clipboard.writeText(window.location.href).then(function(){toast('Link copied');});}return;}
      var summary=e.target.closest('[data-uc-social-summary]');
      if(summary&&content){shareSummary(summary,article,content);}
    });
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
